"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RcrtShare = void 0;
const index_1 = require("../index");
const model_core_1 = require("@nxt/model-core");
class RcrtShare extends model_core_1.Base {
    title = '';
    description = '';
    orientation = 'square';
    ratio = 1;
    elements = [];
    background = {
        position: 'relative',
        backgroundColor: '',
        borderRadius: '20px'
    };
    backgroundImg = '';
    user_id = '';
    shortUrl = '';
    team = null;
    results_clicks = 0;
    results_pviews = 0;
    results_plays = 0;
    results_card = 0;
    sharePath() {
        if (this._docRef.parent.parent.parent.id === 'event_refs') {
            return `/public/ev/${this._docRef.parent.parent.parent.parent.id}/${this._docRef.parent.parent.id}/${this.id}`;
        }
        else {
            return `/public/player/${this._docRef.parent.parent.id}/${this.id}`;
        }
    }
    constructor(data, olMap) {
        super('shares', 14);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, index_1.RcrtEventRef);
    }
    // getGameOpponentImg(index: number): string {
    //     return `/api/profile/${this._docRef.parent.parent.parent.parent.id}/${this._docRef.parent.parent.id}/${this.id}/team/${index}`
    // }
    toJSON() {
        let r = super.toJSON();
        delete r.background.backgroundImage;
        return r;
    }
}
exports.RcrtShare = RcrtShare;
index_1.olm.shares = (ref, map) => {
    return new RcrtShare(ref, map);
};
